import create from 'zustand';

type AuthKeyState = {
  gcKey: string | undefined;
  setGCKey: (gcKey: string | undefined) => void;
};

const useAuthKeyStore = create<AuthKeyState>((set, _get) => ({
  gcKey: undefined,
  reset: (): void => {
    set({
      gcKey: undefined,
    });
  },
  setGCKey: (gcKey: string | undefined) => {
    set((_state) => ({ gcKey }));
  },
}));

export default useAuthKeyStore;
